














































import { Vue, Prop, Component } from "vue-property-decorator";
import { Bill as IBill } from "@/api-v2/agent/models/bill";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import AgentBillTableItem from "@/components/reports/AgentBillTableItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, AgentBillTableItem, CustomTable, CBlock }
})
export default class AgentBillTable extends Vue {
  @Prop({ default: () => [] }) bills!: IBill[];
  @Prop({ default: false }) isLoading?: boolean;
  @Prop({ default: 0 }) count?: number;

  get isShowAddMoreButton(): boolean {
    return this.bills?.length < (this.count ?? 0);
  }

  get summaryAmount() {
    return this.bills?.reduce((acc, curr) => acc + curr.price, 0);
  }

  get summaryDebt() {
    return this.bills?.reduce((acc, curr) => acc + curr.debt, 0);
  }

  showMore() {
    return this.$emit("showMore");
  }
}
